import axios from 'axios';

const sendReservationReceivedNotification = async (reservation) => {
  try {
    const response = await axios.post('https://us-central1-merced-booking.cloudfunctions.net/sendReservationReceivedNotification', reservation, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error al enviar notificación de reservación recibida:', error);
    throw error;
  }
};

const sendReservationConfirmationRequest = async (reservation) => {
  try {
    const response = await axios.post('https://us-central1-asador-1293f.cloudfunctions.net/sendReservationConfirmationRequest', reservation, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error al enviar solicitud de confirmación de reservación:', error);
    throw error;
  }
};

const sendReservationStatusUpdate = async (statusUpdate) => {
  try {
    const response = await axios.post('https://us-central1-merced-booking.cloudfunctions.net/sendReservationStatusUpdate', statusUpdate, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error sending status update:', error);
    throw error;
  }
};

export { sendReservationReceivedNotification, sendReservationConfirmationRequest, sendReservationStatusUpdate };
